import { color } from '@upstox/upstox-ui';

export const header: CSSFunction = () => ({
  padding: '16px',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexGrow: 0,
});

export const title: CSSFunction = ({ theme }) => ({
  fontWeight: theme.fontWeights.bold,
  fontSize: '16px',
  color: color(theme, 'text.1'),
});

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
  color: color(theme, 'icon1'),
});

export const dropdownButton: CSSFunction = ({ theme }) => ({
  borderRadius: '4px',
  border: `1px solid ${color(theme, 'ui3')}`,
  color: color(theme, 'text.1'),
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  fontFamily: theme.fonts.tvFont,
  justifyContent: 'space-between',
  width: '160px',
});

export const dropdownOption: CSSFunction = ({ theme }) => ({
  padding: '6px 0',
  cursor: 'pointer',
  color: color(theme, 'text.1'),
});
